
















































































































































import Vue from 'vue';
import MoneyDisplay from '@/components/MoneyDisplay.vue';
import Tabs from "../../../components/Tabs.vue";
import http, { handleApiResponse } from '@/services/http';
import { ColumnType } from '@/components/apiSearch/models/ApiSearch';
import TransactionItem from '../models/TransactionItem';
import InvoiceMirror, {InvoiceMirrorDefaultProps} from '../models/InvoiceMirror';
import { t } from "@/plugins/i18n";

type TransactionItemDimension = any;

interface Data {
  url: string;
  unfilteredDimensions: TransactionItemDimension[];
  itemInvoiceMirror: InvoiceMirror;
  filteredDimensions: any[];
}

interface Methods {
  preSetItems(e: any): void;
  setItems(e: string, dimCodeType: number): void;
}

interface Computed{
  dim4columns: any[];
  dim5columns: any[];
  dim6columns: any[];
  dim7columns: any[];
  dim8columns: any[];
  dim9columns: any[];
  dim10columns: any[];
  dim11columns: any[];
  dim12columns: any[];
}

interface Props{
  transactionItem: TransactionItem;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    transactionItem: { type: Object as () => TransactionItem}
  },

  components: {
    Tabs,
    MoneyDisplay,
  }, 

  data() {
    return {
      url: "",
      unfilteredDimensions: [],
      itemInvoiceMirror: {...InvoiceMirrorDefaultProps},
      filteredDimensions: [],
    }
  },

  async beforeMount() {
    this.url = `general-ledger-transaction/transactions/items/${this.$props.transactionItem.id}/dimension`;
    const apiSearch = {
      pageSize: 100,
      filter: null,
      extraFilter: null,
      sort: null,
      searchText: "",
    }
    this.unfilteredDimensions = ((await http.post(this.url, apiSearch).then(handleApiResponse)) as any).currentPage;
    this.itemInvoiceMirror = (await http.post("general-ledger-transaction/detail/invoice-mirror/by-account",{year: this.$props.transactionItem.accDate.split("-")[0], accno: this.$props.transactionItem.accNo})).data.data;

    const keys: (keyof InvoiceMirror)[] =  ['dim4', 'dim5', 'dim6', 'dim7', 'dim8', 'dim9', 'dim10', 'dim11', 'dim12'];
    const index = keys.findIndex(key => Number(this.itemInvoiceMirror[key]) != 2);
    (this.$refs.tab as any).setTab((index));
    this.setItems(keys[index],(index+5))
  },

  methods: {
    setItems(e: string, dimCodeType: number) {
      setTimeout(() => {
        this.filteredDimensions = this.unfilteredDimensions.filter((x) => x.dimCodeType == dimCodeType);
      }, 10);
    },

    preSetItems(e: any) {
      this.setItems(e.target.classList[0],Number(e.target.dataset.type));
    }
  },

  computed: {
    dim4columns: () => [
      {
        field: "id",
        title: t("Azonosito")
      },
      {
        field: "dimCodeName",
        title: t("DimenzioKod")
      },
      {
        field: "total",
        title: t("Osszeg"),
        filterable: false,
        cell: "totalTemplate",
        type: ColumnType.Right,
      },
    ],

    dim5columns: () => [
      {
        field: "id",
        title: t("Azonosito")
      },
      {
        field: "dimCodeName",
        title: t("DimenzioKod")
      },
      {
        field: "extProdParts",
        title: t("Transactions_CikkID")
      },
      {
        field: "extProdPartsName",
        title: t("Cikkszam")
      },
      {
        field: "total",
        title: t("Osszeg"),
        filterable: false,
        cell: "totalTemplate",
        type: ColumnType.Right,
      },
    ],

    dim6columns: () => [
      {
        field: "id",
        title: t("Azonosito")
      },
      {
        field: "dimCodeName",
        title: t("DimenzioKod")
      },
      {
        field: "parts",
        title: t("GyartottTermek")
      },
      {
        field: "partsCode",
        title: t("Cikkszam")
      },
      {
        field: "partsName",
        title: t("Transactions_GyariAlkatresz")
      },
      {
        field: "stock",
        title: t("KeszletID")
      },
      {
        field: "total",
        title: t("Osszeg"),
        filterable: false,
        cell: "totalTemplate",
        type: ColumnType.Right,
      },
    ],

    dim7columns: () => [
      {
        field: "id",
        title: t("Azonosito")
      },
      {
        field: "dimCodeName",
        title: t("DimenzioKod")
      },
      {
        field: "carId",
        title: t("Gepjarmu")
      },
      {
        field: "regNum",
        title: t("Rendszam")
      },
      {
        field: "total",
        title: t("Osszeg"),
        filterable: false,
        cell: "totalTemplate",
        type: ColumnType.Right,
      },
    ],

    dim8columns: () => [
      {
        field: "id",
        title: t("Azonosito")
      },
      {
        field: "dimCodeName",
        title: t("DimenzioKod")
      },
      {
        field: "userName",
        title: t("Munkatars")
      },
      {
        field: "stationName",
        title: t("Munkaallomas")
      },
      {
        field: "toolName",
        title: t("Szerszam")
      },
      {
        field: "total",
        title: t("Osszeg"),
        filterable: false,
        cell: "totalTemplate",
        type: ColumnType.Right,
      },
    ],

    dim9columns: () => [
      {
        field: "id",
        title: t("Azonosito")
      },
      {
        field: "dimCodeName",
        title: t("DimenzioKod")
      },
      {
        field: "project",
        title: t("Transactions_ProjektID")
      },
      {
        field: "projectName",
        title: t("Nev")
      },
      {
        field: "projectMainCode",
        title: t("BelsoID")
      }, 
      {
        field: "projectCode",
        title: t("KulsoID")
      },  
      {
        field: "total",
        title: t("Osszeg"),
        filterable: false,
        cell: "totalTemplate",
        type: ColumnType.Right,
      },
    ],

    dim10columns: () => [
      {
        field: "id",
        title: t("Azonosito")
      },
      {
        field: "dimCodeName",
        title: t("DimenzioKod")
      },
      {
        field: "extProdPartner",
        title: t("Transactions_KiegeszitoPartnerID")
      },
      {
        field: "extProdPartnerName",
        title: t("PartnerNev")
      }, 
      {
        field: "total",
        title: t("Osszeg"),
        filterable: false,
        cell: "totalTemplate",
        type: ColumnType.Right,
      },
    ],

    dim11columns: () =>[
      {
        field: "id",
        title: t("Azonosito")
      },
      {
        field: "dimCodeName",
        title: t("DimenzioKod")
      },
      {
        field: "accGroupName",
        title: t("Koltseghely")
      },
      {
        field: "total",
        title: t("Osszeg"),
        filterable: false,
        cell: "totalTemplate",
        type: ColumnType.Right,
      },
    ],

    dim12columns: () =>[
      {
        field: "id",
        title: t("Azonosito")
      },
      {
        field: "dimCodeName",
        title: t("DimenzioKod")
      },
      {
        field: "projectName",
        title: t("Nev")
      },
      {
        field: "projectMainCode",
        title: t("BelsoID")
      }, 
      {
        field: "projectCode",
        title: t("KulsoID")
      },  
      {
        field: "workNumber",
        title: t("Munkaszam")
      },
      {
        field: "total",
        title: t("Osszeg"),
        filterable: false,
        cell: "totalTemplate",
        type: ColumnType.Right,
      },
    ],
  },
})
